module.exports = __webpack_public_path__ + "0411f8e29280434a557eb3fde562940d.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/piano/16_D#3.mp3
// module id = 96
// module chunks = 0